import { FormGroup } from '@angular/forms';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';

export abstract class NotificacionCorreoServiceVM {
  public abstract guardarCorreoNotificacion(form: FormGroup): Promise<GeneralResponse<any>>;
}
